module.exports = __webpack_public_path__ + "static/media/anketa_mocnaya_kartka.91f521c3.doc";